import React from 'react'
import {default as Menu} from 'components/Layout/MainMenu'
import {SIDEBAR_ITEMS} from './constants'


const MainMenu = ({isMini}) => (<Menu isSideBarMini={isMini} SIDEBAR_ITEMS={SIDEBAR_ITEMS} defaultOpenKeys={['manage_group']}/>)

export default MainMenu
